import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  routeTypes: [],
  status: 'idle',
  error: null,
}

export const routeTypeSlice = createSlice({
  name: 'routeType',
  initialState,
  reducers: {
    setRouteTypes: (state, action) => {
      state.routeTypes = action.payload
    },
  },
})

export const { setRouteTypes } = routeTypeSlice.actions

export default routeTypeSlice.reducer 